import { api } from './base';

import { Pageable } from 'v2/types';
import { SWRKeyPaginationWithExtra } from 'v2/types/swr';
import { UsersReferral } from 'v2/types/UserModel';

export const referralsService = {
  getUserReferrals([_key, page, limit, userId]: SWRKeyPaginationWithExtra<string>): Promise<Pageable<UsersReferral>> {
    return api.get(`v1/admin/user/${userId}/referrals`, { searchParams: { page, limit } }).json();
  },
};
